import { render, staticRenderFns } from "./TabelaDetalhesCategoria.vue?vue&type=template&id=563d6beb&scoped=true"
import script from "./TabelaDetalhesCategoria.vue?vue&type=script&lang=js"
export * from "./TabelaDetalhesCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d6beb",
  null
  
)

export default component.exports